import { QueryDocumentSnapshot, SnapshotOptions } from "firebase/firestore";

export default class EventBonus {
  public id: string;
  public comment: string;
  public fromName: string;
  public fromUserId: string;
  public mediumId: string;
  public score: number;
  public teamId: string;

  constructor(id: string, data: Partial<EventBonus>) {
    this.id = id;
    this.comment = data.comment || "";
    this.fromName = data.fromName || "";
    this.fromUserId = data.fromUserId || "";
    this.mediumId = data.mediumId || "";
    this.score = data.score || 0;
    this.teamId = data.teamId || "";
  }

  static firestoreConverter = {
    toFirestore(bonus: EventBonus) {
      return {
        comment: bonus.comment,
        fromName: bonus.fromName,
        fromUserId: bonus.fromUserId,
        mediumId: bonus.mediumId,
        score: bonus.score,
        teamId: bonus.teamId
      };
    },

    fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions) {
      return new EventBonus(snapshot.id, snapshot.data(options));
    }
  };
}
